module.exports = __webpack_public_path__ + "img/favicon.b4c9e8d8.png";